<rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
  <div class="inputs">
    <div class="field">
      <div class="label">Name</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="category.name" placeholder="Name" rsValid="cat_name" />
        </mat-form-field>
      </div>
    </div>
    <div class="field">
      <div class="label">Icon</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Icon</mat-label>

          <mat-icon matPrefix class="icon-2x mr-2">{{ category.icon || 'help_outline' }}</mat-icon>
          <mat-select [(ngModel)]="category.icon" rsValid="cat_icon">
            <mat-select-trigger>
              {{ category.icon | camelConvert }}
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search placeholderLabel="Search" noEntriesFoundLabel="Nothing found.."
                                     [ngModel]="iconSearch" (ngModelChange)="iconSearch = $event; filterIcons()"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let icon of filteredIcons | async" [value]="icon.name">
              <mat-icon>{{icon.name}}</mat-icon> {{icon.name | camelConvert}}
            </mat-option>
          </mat-select>

          <!--<mat-icon matPrefix class="icon-2x mr-2">{{ category.icon || 'help_outline' }}</mat-icon>
          <input matInput [(ngModel)]="category.icon" placeholder="Icon"  rsValid="cat_icon" />-->
        </mat-form-field>
        <a mat-mini-fab class="ml-2 mt-2" color="primary" href="https://fonts.google.com/icons" target="_blank">
          <mat-icon>manage_search</mat-icon>
        </a>
      </div>
    </div>
    <div class="field">
      <div class="label">Color</div>
      <div class="input">
        <color-compact
          [color]="category.color"
          (onChangeComplete)="category.color = $event.color.hex"
        ></color-compact>
      </div>
    </div>
    <div class="field">
      <div class="label">Archived</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-slide-toggle
            [(ngModel)]="category.archived"
            style="user-select: none;"
          >
            <ng-container *ngIf="category.archived">Yes</ng-container>
            <ng-container *ngIf="!category.archived">No</ng-container>
          </mat-slide-toggle>
          <textarea matInput hidden style="display: none !important;"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
</rsValidForm>
<br/>
<ng-template #actionButtons>

  <button mat-button (click)="close()">
    Cancel
  </button>

  <button color="primary" mat-button (click)="saveCategory()">
    <mat-icon>save</mat-icon> Save
  </button>

</ng-template>


